module.exports = __webpack_public_path__ + "static/img/cDR12.94baccd5.png";